module.exports = __webpack_public_path__ + "media/favourite-aspects.5114cf4c.jpg";